//Don't remove line below
(function (jQuery) {